import GifSwatIngenieria from '../../../assets/images/SwatGif3T[1].gif';

const CustomLoader = ({ show, mensaje = "Cargando información..." }) => {
  if (!show) return null;

  return (
    <div className="custom-loader-overlay">
      <div className="loader-card">
        <div className="gif-circle-container">
          <img
            src={GifSwatIngenieria}
            alt="Cargando"
            className="gif-image"
          />
        </div>
        {mensaje && <h6 className="loader-text">{mensaje}</h6>}
      </div>

      <style>{`
                .custom-loader-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    /* Fondo oscuro muy sutil y desenfoque detrás */
                    background: rgba(0, 0, 0, 0.2); 
                    backdrop-filter: blur(4px);
                    -webkit-backdrop-filter: blur(4px);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 9999;
                    transition: all 0.3s ease;
                }

                .loader-card {
                    background: white;
                    padding: 2rem;
                    border-radius: 20px;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-width: 200px;
                }

                .gif-circle-container {
                    width: 100px;
                    height: 100px;
                    border-radius: 50%;
                    overflow: hidden;
                    border: 3px solid #f0f0f0; /* Borde circular sutil */
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: white;
                    box-shadow: inset 0 0 10px rgba(0,0,0,0.05);
                }

                .gif-image {
                    width: 80%; /* Ajusta esto según cómo se vea tu GIF original */
                    height: auto;
                    object-fit: contain;
                }

                .loader-text {
                    margin-top: 1.2rem;
                    color: #444;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                    font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                }
            `}</style>
    </div>
  );
};

export default CustomLoader;